import { render, staticRenderFns } from "./StandardBanner.vue?vue&type=template&id=072a1192&"
import script from "./StandardBanner.vue?vue&type=script&lang=js&"
export * from "./StandardBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports